/**
 * MSW Free Gift Auto-Add
 * Auto-adds a free Hook Strap when cart has a qualifying Cap + Strap combo.
 * - Caps gift at qty 1
 * - Removes rogue gifts (added without _free_gift property or without qualifier)
 * - Validates on every cart change + before checkout
 */
(function() {
  'use strict';

  var FREE_GIFT_VARIANT_ID = 47821285228788;
  var FREE_GIFT_PRODUCT_ID = 9374571823348;

  var CAP_PRODUCT_IDS = [8933422006516, 8869394284788];
  var STRAP_PRODUCT_IDS = [8869397987572];
  var BUNDLE_PRODUCT_IDS = [9251096428788, 8885339652340, 8881256366324, 9323655790836];

  var busy = false;

  console.log('[FG] loaded');

  function checkCart() {
    if (busy) return;
    busy = true;
    console.log('[FG] checking...');

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onload = function() {
      try {
        var cart = JSON.parse(xhr.responseText);
        var items = cart.items || [];
        var giftLine = -1;
        var giftQty = 0;
        var rogueGiftLine = -1;
        var hasCap = false, hasStrap = false, hasBundle = false;

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var isGiftVariant = item.variant_id === FREE_GIFT_VARIANT_ID;
          var hasProp = item.properties && item.properties._free_gift;

          if (isGiftVariant && hasProp) {
            giftLine = i + 1;
            giftQty = item.quantity;
          } else if (isGiftVariant && !hasProp) {
            // Rogue gift - added manually without _free_gift property
            rogueGiftLine = i + 1;
          }

          if (BUNDLE_PRODUCT_IDS.indexOf(item.product_id) !== -1) hasBundle = true;
          if (CAP_PRODUCT_IDS.indexOf(item.product_id) !== -1) hasCap = true;
          if (STRAP_PRODUCT_IDS.indexOf(item.product_id) !== -1) hasStrap = true;
        }

        var qualifies = hasBundle || (hasCap && hasStrap);
        var hasGift = giftLine > 0;

        console.log('[FG] qualifies=' + qualifies + ' hasGift=' + hasGift + ' giftQty=' + giftQty + ' rogueGift=' + (rogueGiftLine > 0));

        // Priority 1: Remove rogue gifts (no _free_gift property)
        if (rogueGiftLine > 0) {
          console.log('[FG] removing rogue gift at line ' + rogueGiftLine);
          cartChange(rogueGiftLine, 0, function() {
            busy = false;
            doRefresh();
            // Re-check in case there are more issues
            setTimeout(checkCart, 500);
          });
          return;
        }

        // Priority 2: Cap gift qty at 1
        if (hasGift && giftQty > 1) {
          console.log('[FG] capping gift qty from ' + giftQty + ' to 1');
          cartChange(giftLine, 1, function() {
            busy = false;
            doRefresh();
          });
          return;
        }

        // Priority 3: Add gift if qualifying and missing
        if (qualifies && !hasGift) {
          console.log('[FG] adding gift');
          var addXhr = new XMLHttpRequest();
          addXhr.open('POST', '/cart/add.js', true);
          addXhr.setRequestHeader('Content-Type', 'application/json');
          addXhr.onload = function() {
            console.log('[FG] added! status=' + addXhr.status);
            busy = false;
            doRefresh();
          };
          addXhr.onerror = function() { busy = false; };
          addXhr.send(JSON.stringify({
            items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1, properties: { _free_gift: 'true' } }]
          }));
          return;
        }

        // Priority 4: Remove gift if not qualifying
        if (!qualifies && hasGift && giftLine > 0) {
          console.log('[FG] removing gift (no qualifier)');
          cartChange(giftLine, 0, function() {
            busy = false;
            doRefresh();
          });
          return;
        }

        busy = false;
      } catch(e) {
        console.error('[FG] error:', e);
        busy = false;
      }
    };
    xhr.onerror = function() { busy = false; };
    xhr.send();
  }

  function cartChange(line, qty, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/change.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() { callback(); };
    xhr.onerror = function() { callback(); };
    xhr.send(JSON.stringify({ line: line, quantity: qty }));
  }

  function doRefresh() {
    if (typeof window.mswCartRefresh === 'function') {
      console.log('[FG] refreshing cart drawer...');
      window.mswCartRefresh();
    } else {
      window.location.reload();
    }
  }

  // Expose globally
  window.mswCheckFreeGift = checkCart;

  // Check on page load
  setTimeout(checkCart, 1500);

  // CHECKOUT GUARD: Intercept checkout form submissions
  // If someone tries to checkout with a rogue gift or without qualifying items, clean cart first
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/checkout') !== -1) {
      // Quick synchronous check - block checkout, verify cart, then allow
      e.preventDefault();
      console.log('[FG] checkout intercepted, validating cart...');

      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', true);
      xhr.onload = function() {
        try {
          var cart = JSON.parse(xhr.responseText);
          var items = cart.items || [];
          var needsClean = false;
          var hasCap = false, hasStrap = false, hasBundle = false;

          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.variant_id === FREE_GIFT_VARIANT_ID) {
              if (!(item.properties && item.properties._free_gift)) needsClean = true;
              if (item.quantity > 1) needsClean = true;
            }
            if (BUNDLE_PRODUCT_IDS.indexOf(item.product_id) !== -1) hasBundle = true;
            if (CAP_PRODUCT_IDS.indexOf(item.product_id) !== -1) hasCap = true;
            if (STRAP_PRODUCT_IDS.indexOf(item.product_id) !== -1) hasStrap = true;
          }

          var qualifies = hasBundle || (hasCap && hasStrap);
          var hasGiftInCart = items.some(function(i) { return i.variant_id === FREE_GIFT_VARIANT_ID; });

          if (!qualifies && hasGiftInCart) needsClean = true;

          if (needsClean) {
            console.log('[FG] cart needs cleaning before checkout');
            // Remove all gift variants
            var giftLines = [];
            for (var j = items.length - 1; j >= 0; j--) {
              if (items[j].variant_id === FREE_GIFT_VARIANT_ID) giftLines.push(j + 1);
            }
            // Remove from bottom up to keep line indices valid
            (function removeNext() {
              if (giftLines.length === 0) {
                // Re-submit checkout
                form.submit();
                return;
              }
              var line = giftLines.shift();
              cartChange(line, 0, removeNext);
            })();
          } else {
            // Cart is clean, proceed to checkout
            form.submit();
          }
        } catch(e) {
          // On error, just let them checkout
          form.submit();
        }
      };
      xhr.onerror = function() { form.submit(); };
      xhr.send();
    }
  }, true); // useCapture to intercept early

  // Also intercept checkout links (e.g. /checkout URL clicks)
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/checkout"]');
    if (link) {
      e.preventDefault();
      console.log('[FG] checkout link intercepted, validating...');
      // Trigger a check, then redirect
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', true);
      xhr.onload = function() {
        try {
          var cart = JSON.parse(xhr.responseText);
          var items = cart.items || [];
          var hasCap = false, hasStrap = false, hasBundle = false;
          var hasAnyGift = false;

          for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id === FREE_GIFT_VARIANT_ID) hasAnyGift = true;
            if (BUNDLE_PRODUCT_IDS.indexOf(items[i].product_id) !== -1) hasBundle = true;
            if (CAP_PRODUCT_IDS.indexOf(items[i].product_id) !== -1) hasCap = true;
            if (STRAP_PRODUCT_IDS.indexOf(items[i].product_id) !== -1) hasStrap = true;
          }

          var qualifies = hasBundle || (hasCap && hasStrap);

          if (!qualifies && hasAnyGift) {
            // Clean then redirect
            var giftLines = [];
            for (var j = items.length - 1; j >= 0; j--) {
              if (items[j].variant_id === FREE_GIFT_VARIANT_ID) giftLines.push(j + 1);
            }
            (function removeNext() {
              if (giftLines.length === 0) { window.location.href = link.href; return; }
              cartChange(giftLines.shift(), 0, removeNext);
            })();
          } else {
            window.location.href = link.href;
          }
        } catch(e) { window.location.href = link.href; }
      };
      xhr.onerror = function() { window.location.href = link.href; };
      xhr.send();
    }
  }, true);

})();
